export default __webpack_public_path__ + "static/media/video.6cc97121.svg";